"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiDialogOverrides = void 0;
var createMuiDialogOverrides = function (_a) {
    var palette = _a.palette;
    return ({
        paper: {
            border: "1px solid " + palette.divider,
            backgroundColor: palette.background.default,
            color: palette.text.secondary,
        },
    });
};
exports.createMuiDialogOverrides = createMuiDialogOverrides;
//# sourceMappingURL=MuiDialog.js.map